import type { SubmitStatus } from "@/hooks/useEnquirySubmit";

interface FormStatusProps {
  status: SubmitStatus;
  message: string;
  referenceId?: string;
}

export default function FormStatus({ status, message, referenceId }: FormStatusProps) {
  if (status === "idle" || status === "submitting") return null;

  if (status === "success") {
    return (
      <div className="mt-6 rounded-lg border border-primary-300 bg-primary-50 p-5" role="status" aria-live="polite">
        <div className="flex items-start gap-3">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary-500 text-foreground-950">
            <i className="ri-checkbox-circle-line text-lg" />
          </span>
          <div>
            <p className="font-label text-sm font-semibold text-primary-900">{message}</p>
            {referenceId ? (
              <p className="mt-1.5 text-sm text-primary-800">
                Your enquiry reference: <span className="font-label font-bold">{referenceId}</span>
              </p>
            ) : null}
            <p className="mt-2 text-xs leading-relaxed text-primary-800/90">
              Final retrofit feasibility is subject to technical assessment. Our team will review your
              details and get in touch through the official channel.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-6 rounded-lg border border-accent-400 bg-accent-50 p-5" role="alert" aria-live="assertive">
      <div className="flex items-start gap-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
          <i className="ri-error-warning-line text-lg" />
        </span>
        <div>
          <p className="font-label text-sm font-semibold text-accent-900">Could not submit</p>
          <p className="mt-1 break-words text-sm text-accent-900/90">{message}</p>
        </div>
      </div>
    </div>
  );
}